import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

window.addEventListener('error', (event) => {
  if (event.message?.includes('Failed to fetch dynamically imported module')) {
    window.location.reload();
  }
}, true);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

  